module.exports = __webpack_public_path__ + "media/images/articles/work_experience_resume/cover-f33f4adf3d8957e640e83c0ef0cf47d7.png";